import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const getGlobalBlacklist = unaryRpc({
  name: "getGlobalBlacklist",
  input: z.object({}),
  output: z.object({
    terms: z.array(
      z.object({
        id: z.string(),
        term: z.string(),
        createdBy: z.string(),
        createdAt: z.string(),
      }),
    ),
  }),
});
